import { useIntl } from '@capsicum/common';

export const useWCPledgeSuccessModalTexts = () => {
	const { $t } = useIntl();
	const title = (amountStaked: number | string) =>
		$t('worldChampionshipPledge.modals.success.title', { amountStaked });
	const subtitle = $t('worldChampionshipPledge.modals.success.subtitle');
	const content = $t('worldChampionshipPledge.modals.success.content');
	const buttonText = $t('worldChampionshipPledge.modals.success.buttonText');

	return {
		buttonText,
		content,
		subtitle,
		title
	};
};
